export default __webpack_public_path__ + "static/19-f036dc7490bcbb737789307cb9d1f603.png";